import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_ANSWERS,
  ENDPOINT_ANSWER_INTERVEW,
  ENDPOINT_PREPARE_ANSWERS_FOR_INTERVIEW,
  ENDPOINT_RESEND_ANSWERS_INTERVIEW,
  ENDPOINT_RESEND_ANSWERS_INTERVIEW_MUTIPLE,
  ENDPOINT_SEND_ANSWERS_INTERVIEW,
  ENDPOINT_VALIDATE_FILTER_BY_ANSWER,
  ENDPOIfNT_AVALIAR_ENTREVISTA,
} from './constants';

export function useAnswerService() {
  const { backendGet, backendPatch, backendPost, backendPut } =
    Sebrae.useBackend();

  const findAnswersByInterview = React.useCallback(
    (idInterview) => backendGet(`${ENDPOINT_ANSWER_INTERVEW}/${idInterview}`),
    [backendGet],
  );

  const validateInterviewInitialized = React.useCallback(
    (idInterview) =>
      backendGet(
        `${ENDPOINT_ANSWER_INTERVEW}/${idInterview}/validate-interview-initialized`,
      ),
    [backendGet],
  );

  const findAnswersByInterviewStartup = React.useCallback(
    (idInterview) =>
      backendGet(
        `${ENDPOINT_ANSWER_INTERVEW}/${idInterview}/startup-avaliation`,
      ),
    [backendGet],
  );

  const putAvaliarEntrevista = React.useCallback(
    (id, option) =>
      backendPut(
        `${ENDPOIfNT_AVALIAR_ENTREVISTA}/${id}/evaluate?option=${option}`,
      ),
    [backendPut],
  );

  const putValidateAnswersFilter = React.useCallback(
    (id) => backendPut(`${ENDPOINT_VALIDATE_FILTER_BY_ANSWER}/${id}`),
    [backendPut],
  );

  const prepareAnswersForInterview = React.useCallback(
    (interviewId) =>
      backendPost(`${ENDPOINT_PREPARE_ANSWERS_FOR_INTERVIEW}/${interviewId}`),
    [backendPost],
  );

  const creteNewAnswer = React.useCallback(
    (answer) => backendPost(`${ENDPOINT_ANSWERS}`, answer),
    [backendPost],
  );

  const update = React.useCallback(
    (answer) => backendPatch(`${ENDPOINT_ANSWERS}/${answer.id}`, answer),
    [backendPatch],
  );

  const sendAnswer = React.useCallback(
    (sendAnswerInterview, idModule) =>
      backendPost(
        `${ENDPOINT_SEND_ANSWERS_INTERVIEW}/${idModule}`,
        sendAnswerInterview,
      ),
    [backendPost],
  );

  const resendAnswer = React.useCallback(
    (idInterview) =>
      backendPost(`${ENDPOINT_RESEND_ANSWERS_INTERVIEW}`, {
        idInterview: idInterview,
      }),
    [backendPost],
  );

  const resendAnswerMutiple = React.useCallback(
    (idInterviewList) =>
      backendPost(`${ENDPOINT_RESEND_ANSWERS_INTERVIEW_MUTIPLE}`, {
        idsInterview: idInterviewList,
      }),
    [backendPost],
  );

  return {
    findAnswersByInterview,
    resendAnswerMutiple,
    prepareAnswersForInterview,
    creteNewAnswer,
    update,
    sendAnswer,
    resendAnswer,
    putValidateAnswersFilter,
    findAnswersByInterviewStartup,
    putAvaliarEntrevista,
    validateInterviewInitialized,
  };
}
